import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import MinusIcon from '@material-ui/icons/Remove';
import WarningIcon from '@material-ui/icons/Warning';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { ReactElement } from 'react';
import { JupiterTheme } from '../theme/types';

const useIconStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      color: theme.palette.background.paper,
      opacity: 0.65,
      height: 18,
      width: 18,
    },
    loadingSvg: {
      color: theme.palette.common.white,
    },
  })
);

export type Icon =
  | 'check'
  | 'exclamation'
  | 'x'
  | 'minus'
  | 'question'
  | 'error'
  | 'loading'
  | 'warning';

export interface IndicatorChipIconProps {
  icon?: Icon | React.ComponentType<any>;
}

export default function IndicatorChipIcon({
  icon: Icon,
}: IndicatorChipIconProps) {
  const classes = useIconStyles();
  let iconElement: ReactElement<any> | null = null;

  switch (Icon) {
    case 'check':
      iconElement = (
        <CheckIcon data-testid="check-icon" className={classes.icon} />
      );
      break;
    case 'warning':
      iconElement = (
        <WarningIcon
          data-testid="warning-shape-icon"
          className={classes.icon}
        />
      );
      break;
    case 'exclamation':
      iconElement = (
        <PriorityHighIcon
          data-testid="priority-high-icon"
          className={classes.icon}
        />
      );
      break;
    case 'x':
      iconElement = (
        <ClearIcon data-testid="clear-icon" className={classes.icon} />
      );
      break;
    case 'minus':
      iconElement = (
        <MinusIcon data-testid="minus-icon" className={classes.icon} />
      );
      break;
    case 'question':
      iconElement = (
        <HelpOutlineIcon
          data-testid="help-outline-icon"
          className={classes.icon}
        />
      );
      break;
    case 'error':
      iconElement = (
        <ErrorOutlineIcon
          data-testid="error-outline-icon"
          className={classes.icon}
        />
      );
      break;
    case 'loading':
      iconElement = (
        <CircularProgress
          data-testid="circular-progress"
          size={18}
          classes={{
            svg: classes.loadingSvg,
          }}
        />
      );
      break;
    default:
      if (Icon) {
        iconElement = <Icon className={classes.icon} />;
      }
      break;
  }
  return iconElement;
}
